export default __webpack_public_path__ + "static/media/Cane of Decay.3e84f28f.jpg";